/* Reserve actual header heights so the entire desktop film fits on first load. */
(() => {
  'use strict';
  const init = () => {
    const root = document.querySelector('[data-fx-landing]');
    if (!root || root.dataset.heroViewportReady) return;
    root.dataset.heroViewportReady = 'true';
    const parts = [document.querySelector('.zr-toolbar'), root.querySelector('.concept-nav'), root.querySelector('.gl-license'), document.querySelector('.sf-header .header__wrapper'), document.querySelector('#shopify-section-annoucement')].filter(Boolean);
    const update = () => {
      const reviewBar = document.querySelector('#PBarNextFrameWrapper');
      const previewHeight = reviewBar?.getBoundingClientRect().height || 0;
      const height = parts.reduce((total, part) => total + part.getBoundingClientRect().height, previewHeight);
      root.style.setProperty('--fx-hero-top-space', `${Math.ceil(height)}px`);
    };
    update();
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
    parts.forEach(part => observer?.observe(part));
    const watchPreviewBar = () => {
      const bar = document.querySelector('#PBarNextFrameWrapper');
      if (!bar) return false;
      observer?.observe(bar);
      update();
      return true;
    };
    if (!watchPreviewBar()) {
      const insertionObserver = new MutationObserver(() => {
        if (watchPreviewBar()) insertionObserver.disconnect();
      });
      insertionObserver.observe(document.body, { childList: true });
    }
    window.addEventListener('resize', update, { passive: true });
    document.fonts?.ready.then(update);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
